/*
 *
 * Collaborators actions
 *
 */

import {
  GET_TEMPLATE_COLLABORATORS_WATCHER,
  GET_TEMPLATE_COLLABORATORS_SUCCESS,
  GET_TEMPLATE_COLLABORATORS_FAILED,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
  UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
  GET_COLLABORATORS_WATCHER,
  GET_COLLABORATORS_SUCCESS,
  GET_COLLABORATORS_FAILED,
  SEARCH_COLLABORATORS_WATCHER,
  SEARCH_COLLABORATORS_SUCCESS,
  SEARCH_COLLABORATORS_FAILED,
  HAS_DIVISIONS_WATCHER,
  HAS_DIVISIONS_SUCCESS,
  HAS_DIVISIONS_FAILED,
  HAS_COLLABORATORS_WATCHER,
  HAS_COLLABORATORS_SUCCESS,
  HAS_COLLABORATORS_FAILED,
  GET_TEAM_WATCHER,
  GET_TEAM_SUCCESS,
  GET_TEAM_FAILED,
  ASSIGN_LEADER_WATCHER,
  ASSIGN_LEADER_SUCCESS,
  ASSIGN_LEADER_FAILED,
  GET_POTENTIAL_LEADERS_WATCHER,
  GET_POTENTIAL_LEADERS_SUCCESS,
  GET_POTENTIAL_LEADERS_FAILED,
  GET_TEAM_POTENTIAL_WATCHER,
  GET_TEAM_POTENTIAL_SUCCESS,
  GET_TEAM_POTENTIAL_FAILED,
  ADD_EMPLOYEES_TEAM_WATCHER,
  ADD_EMPLOYEES_TEAM_SUCCESS,
  ADD_EMPLOYEES_TEAM_FAILED,
  REMOVE_EMPLOYEES_TEAM_WATCHER,
  REMOVE_EMPLOYEES_TEAM_SUCCESS,
  REMOVE_EMPLOYEES_TEAM_FAILED,
  REMOVE_COLLABORATORS_WATCHER,
  REMOVE_COLLABORATORS_SUCCESS,
  REMOVE_COLLABORATORS_FAILED,
  GET_MEASURES_WATCHER,
  GET_MEASURES_SUCCESS,
  GET_MEASURES_FAILED,
  HAS_SEGMENTS_WATCHER,
  HAS_SEGMENTS_SUCCESS,
  HAS_SEGMENTS_FAILED,
  GET_VISMA_PEOPLE_STATUS_FAILED,
  GET_VISMA_PEOPLE_STATUS_SUCCESS,
  GET_VISMA_PEOPLE_STATUS_WATCHER,
} from "./constants"

// REMOVE COLLABORATORS
export function removeCollaboratorsWatcher(payload) {
  return {
    type: REMOVE_COLLABORATORS_WATCHER,
    payload,
  }
}

export function removeCollaboratorsSuccess(payload) {
  return {
    type: REMOVE_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function removeCollaboratorsFailed(payload) {
  return {
    type: REMOVE_COLLABORATORS_FAILED,
    payload,
  }
}

// REMOVE EMPLOYEES TEAM
export function removeEmployeesTeamWatcher(payload) {
  return {
    type: REMOVE_EMPLOYEES_TEAM_WATCHER,
    payload,
  }
}

export function removeEmployeesTeamSuccess(payload) {
  return {
    type: REMOVE_EMPLOYEES_TEAM_SUCCESS,
    payload,
  }
}

export function removeEmployeesTeamFailed(payload) {
  return {
    type: REMOVE_EMPLOYEES_TEAM_FAILED,
    payload,
  }
}

// ADD EMPLOYEES TEAM
export function addEmployeesTeamWatcher(payload) {
  return {
    type: ADD_EMPLOYEES_TEAM_WATCHER,
    payload,
  }
}

export function addEmployeesTeamSuccess(payload) {
  return {
    type: ADD_EMPLOYEES_TEAM_SUCCESS,
    payload,
  }
}

export function addEmployeesTeamFailed(payload) {
  return {
    type: ADD_EMPLOYEES_TEAM_FAILED,
    payload,
  }
}

// GET TEAM POTENTIAL
export function getTeamPotentialWatcher(payload) {
  return {
    type: GET_TEAM_POTENTIAL_WATCHER,
    payload,
  }
}

export function getTeamPotentialSuccess(payload) {
  return {
    type: GET_TEAM_POTENTIAL_SUCCESS,
    payload,
  }
}

export function getTeamPotentialFailed(payload) {
  return {
    type: GET_TEAM_POTENTIAL_FAILED,
    payload,
  }
}

// ASSIGN LEADER
export function getPotentialLeadersWatcher(payload) {
  return {
    type: GET_POTENTIAL_LEADERS_WATCHER,
    payload,
  }
}

export function getPotentialLeadersSuccess(payload) {
  return {
    type: GET_POTENTIAL_LEADERS_SUCCESS,
    payload,
  }
}

export function getPotentialLeadersFailed(payload) {
  return {
    type: GET_POTENTIAL_LEADERS_FAILED,
    payload,
  }
}

// ASSIGN LEADER
export function assignLeaderWatcher(payload) {
  return {
    type: ASSIGN_LEADER_WATCHER,
    payload,
  }
}

export function assignLeaderSuccess(payload) {
  return {
    type: ASSIGN_LEADER_SUCCESS,
    payload,
  }
}

export function assignLeaderFailed(payload) {
  return {
    type: ASSIGN_LEADER_FAILED,
    payload,
  }
}

// GET TEAM
export function getTeamWatcher(payload) {
  return {
    type: GET_TEAM_WATCHER,
    payload,
  }
}

export function getTeamSuccess(payload) {
  return {
    type: GET_TEAM_SUCCESS,
    payload,
  }
}

export function getTeamFailed(payload) {
  return {
    type: GET_TEAM_FAILED,
    payload,
  }
}

// HAS COLLABORATORS
export function hasCollaboratorsWatcher() {
  return { type: HAS_COLLABORATORS_WATCHER }
}

export function hasCollaboratorsSuccess(payload) {
  return {
    type: HAS_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function hasCollaboratorsFailed(payload) {
  return {
    type: HAS_COLLABORATORS_FAILED,
    payload,
  }
}

// HAS SEGMENTS
export function hasSegmentsWatcher() {
  return { type: HAS_SEGMENTS_WATCHER }
}

export function hasSegmentsSuccess(payload) {
  return {
    type: HAS_SEGMENTS_SUCCESS,
    payload,
  }
}

export function hasSegmentsFailed(payload) {
  return {
    type: HAS_SEGMENTS_FAILED,
    payload,
  }
}

// HAS DIVISIONS
export function hasDivisionsWatcher() {
  return { type: HAS_DIVISIONS_WATCHER }
}

export function hasDivisionsSucces(payload) {
  return {
    type: HAS_DIVISIONS_SUCCESS,
    payload,
  }
}

export function hasDivisionsFailed(payload) {
  return {
    type: HAS_DIVISIONS_FAILED,
    payload,
  }
}

// SEARCH COLLABORATORS
export function searchCollaboratorsWatcher(payload) {
  return {
    type: SEARCH_COLLABORATORS_WATCHER,
    payload,
  }
}

export function searchCollaboratorsSuccess(payload) {
  return {
    type: SEARCH_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function searchCollaboratorsFailed(payload) {
  return {
    type: SEARCH_COLLABORATORS_FAILED,
    payload,
  }
}

// GET COLLABORATORS
export function getCollaboratorsWatcher(payload) {
  return {
    type: GET_COLLABORATORS_WATCHER,
    payload
  }
}

export function getCollaboratorsSuccess(payload) {
  return {
    type: GET_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function getCollaboratorsFailed(payload) {
  return {
    type: GET_COLLABORATORS_FAILED,
    payload,
  }
}

// GET EXCEL
export function getTemplateCollaboratorsWatcher(payload) {
  return {
    type: GET_TEMPLATE_COLLABORATORS_WATCHER,
    payload,
  }
}

export function getTemplateCollaboratorsSuccess(payload) {
  return {
    type: GET_TEMPLATE_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function getTemplateCollaboratorsFailed(payload) {
  return {
    type: GET_TEMPLATE_COLLABORATORS_FAILED,
    payload,
  }
}

// UPLOAD EXCEL
export function uploadTemplateCollaboratorsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
    payload,
  }
}

export function uploadTemplateCollaboratorsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function uploadTemplateCollaboratorsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
    payload,
  }
}

// GET MEASURES
export function getMeasuresWatcher(payload) {
  return {
    type: GET_MEASURES_WATCHER,
    payload,
  }
}

export function getMeasuresSuccess(payload) {
  return {
    type: GET_MEASURES_SUCCESS,
    payload,
  }
}

export function getMeasuresFailed(payload) {
  return {
    type: GET_MEASURES_FAILED,
    payload,
  }
}


export function getVismaPeopleStatusWatcher(payload) {
  return {
    type: GET_VISMA_PEOPLE_STATUS_WATCHER,
    payload,
  }
}

export function getVismaPeopleStatusSuccess(payload) {
  return {
    type: GET_VISMA_PEOPLE_STATUS_SUCCESS,
    payload,
  }
}

export function getVismaPeopleStatusFailed(payload) {
  return {
    type: GET_VISMA_PEOPLE_STATUS_FAILED,
    payload,
  }
}